import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../_services/message.service';

import { UserGroup } from '../_models/user_group';
import { UserZone } from '../_models/user_zone';
import { Zone } from '../_models/zone';

import { Globals } from '../_globals/globals';

import { DbTransform } from '../_helpers/db.transform';



@Injectable({
  providedIn: 'root'
})

export class UserGroupService {

  dbt: DbTransform;

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {
    this.dbt = new DbTransform(localStorage.getItem('enviroment')); //this.globals.currentUserEnviroment);
  }

  getUserGroups(searchParams): Observable<UserGroup[]> {

    console.log('-->--> Ejecutando servicio getUserGroups.');
    // console.log(searchParams);
    // console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<UserGroup[]>(this.globals.apiUrl + '/user_groups', options)
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getUserGroups: ')), // + JSON.stringify(data))),
        catchError(this.handleError<UserGroup[]>('getUserGroups', [])
      ));
  }

  getAllUserGroups(): Observable<UserGroup[]> {

    console.log('-->--> Ejecutando servicio getAllUserGroups');

    return this.http.get<UserGroup[]>(this.globals.apiUrl + '/user_groups')
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getAllUserGroups: ' + JSON.stringify(data))),
        catchError(this.handleError<UserGroup[]>('getAllUserGroups', [])
      ));
  }

  getUserGroup(searchParams): Observable<UserGroup> {

    console.log('-->--> Ejecutando servicio getUserGroup');
    // console.log(searchParams);
    // console.log('---------------');

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: new HttpParams()
        .set('ID', searchParams.id)
    };
    return this.http.get<UserGroup>(this.globals.apiUrl + '/user_group', options)
      .pipe(
        tap(  _ => this.log('get user_group')),
        catchError(this.handleError<UserGroup>('getUserGroup', null)
      ));
  }

  updateUserGroup(userGroupIn: UserGroup): Observable<UserGroup> {

    console.log('-->--> Ejecutando servicio updateUserGroup.');
    // console.log(userGroupIn);
    // console.log('---------------');

    let options = {};
    if (userGroupIn.id === null) {
      options = { params: new HttpParams()
        .set('ID', '0') };
    } else {
      options = { params: new HttpParams()
        .set('ID', userGroupIn[this.dbt.t('id')].toString()) };
    }

    return this.http.put<UserGroup>(this.globals.apiUrl + '/user_group', userGroupIn, options)
      .pipe(
        tap(  _ => this.log('updated user_group')),
        catchError(this.handleError<UserGroup>('updateUserGroup', null)
      ));
  }

  createUserGroup(userGroupIn: UserGroup): Observable<UserGroup> {

    console.log('-->--> Ejecutando servicio createUserGroup.');
    // console.log(userGroupIn);
    // console.log('---------------');

    let options = {};

    return this.http.post<UserGroup>(this.globals.apiUrl + '/user_group', userGroupIn, options)
      .pipe(
        tap(  _ => this.log('created user_group')),
        catchError(this.handleError<UserGroup>('createUserGroup', null)
      ));
  } // End function createUserGroup

  deleteUserGroup(userGroupIn: UserGroup): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteUserGroup.');
    // console.log(userGroupIn);
    // console.log('---------------');

    let options = { params: new HttpParams()
        .set('ID', userGroupIn[this.dbt.t('id')].toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/user_group', options)
      .pipe(
        tap(  _ => this.log('deleted user_group')),
        catchError(this.handleError<bigint>('deleteUserGroup', null)
      ));
  } // End function deleteUserGroup

  createUserZone(userZoenIn: UserZone): Observable<UserZone> {

    console.log('-->--> Ejecutando servicio createUserZone.');
    // console.log(userZoenIn);
    // console.log('---------------');

    let options = {};

    return this.http.post<UserZone>(this.globals.apiUrl + '/userZone', userZoenIn, options)
      .pipe(
        tap(  _ => this.log('created user_zone')),
        catchError(this.handleError<UserZone>('createUserZone', null)
      ));
  } // End function createUserZone

  deleteUserZone(userZoneIn: UserZone): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteUserZone.');
    // console.log(userZoneIn);
    // console.log('---------------');

    let options = { params: new HttpParams()
        .set('ID', userZoneIn[this.dbt.t('id')].toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/userZone', options)
      .pipe(
        tap(  _ => this.log('deleted user_zone')),
        catchError(this.handleError<bigint>('deleteUserZone', null)
      ));
  } // End function deleteUserZone

  getUserZones(searchParams): Observable<UserZone[]> {

    console.log('-->--> Ejecutando servicio getUserZones.');
    // console.log(searchParams);
    // console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    const options = { params: params };

    // console.log('--> -- Options = ');
    // console.log(options);

    return this.http.get<UserZone[]>(this.globals.apiUrl + '/userZones', options)
      .pipe(
        tap( data => console.log(' -> Zonas obtenidas desde getUserZones: ')), // + JSON.stringify(data))),
        catchError(this.handleError<UserZone[]>('getUserZones', [])
      ));
  }

  // -------------------------
  // Para las Zonas asignadas a los grupos de permisos de usuarios
  // -------------------------

  getZones(searchParams): Observable<Zone[]> {

    console.log('-->--> Ejecutando servicio getZones.');
    // console.log(searchParams);
    // console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    const options = { params: params };

    // console.log('--> -- Options = ');
    // console.log(options);

    return this.http.get<Zone[]>(this.globals.apiUrl + '/zonesOracle', options)
      .pipe(
        tap( data => console.log(' -> Nombre de zonas obtenidas desde getZones: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Zone[]>('getZones', [])
      ));
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }
  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
